<template>
	<div>
		<h4 class="font_lg font_bold text-center" style="width:520px;margin:0 auto; padding-bottom: 50px;">Document
			download</h4>

		<table class="center" style="padding-bottom: 100px;">
			<tr>
				<th>Invoices document:</th>
				<th>PODs and other documents:</th>
			</tr>
			<tr>
				<td>
					<a :href="invoiceZipLink || buildDocumentDownloadUrl(invoice.fileId, token)" target="_blank">{{ invoiceZipLink ? 'invoices.zip' : invoice.fileName }}</a>
				</td>
				<td>
					<a :href="podsZipLink || buildDocumentDownloadUrl(pods && pods[0] ? pods[0].fileId : '', token)" target="_blank">
						{{ podsZipLink ? 'pods.zip' : pods && pods[0] ? pods[0].fileName : "" }}</a>
				</td>
			</tr>
			<tr v-for="(pod, index) in pods">
				<td></td>
				<td v-if="index > 0">
					<a :href="buildDocumentDownloadUrl(pod.fileId, token)" target="_blank"> {{ pod.fileName }}</a>
				</td>
			</tr>
		</table>
	</div>
</template>
<script>
import {fileuploadApi} from "@/common/api/fileuploadApi";
import {receivableApi} from "src/common/api/receivableApi";

export default {
	data() {
		return {
			purpose: "",
			token: "",
			invoice: {},
			pods: [],
			invoiceZipLink: "",
			podsZipLink: ""
		};
	},
	beforeMount() {
		let { query } = this.$route;
		if (query && query.token) {
			this.token = query.token;
			this.purpose = query.purpose;

			receivableApi
				.allReceivableDocuments(this.token, this.purpose)
				.then(res => {
					this.invoice = res.invoice;
					this.pods = res.podFiles;
					this.invoiceZipLink = res.invoiceZipLink;
					this.podsZipLink = res.podsZipLink;
				})
				.catch(() => {
				});
		}
	},
	methods: {
		buildDocumentDownloadUrl(fileId, token) {
			return fileuploadApi.getPdfViaTokenUrl(fileId, token);
		}
	}
};
</script>
<style lang="scss" scoped>
.center {
	margin-left: auto;
	margin-right: auto;
}

td {min-width: 350px;
	max-width: 350px;
	padding-left: 100px
}

th {
	text-align: left;
	padding-left: 100px;
}
</style>